export default "__VITE_ASSET__BBDNQ486__"